module.exports = __webpack_public_path__ + "media/application/images/ui/blurred_how_we_test_mobile-b9f6956cdfed71da37f8c144e26933f2.png";